import { Box, Stack, Typography } from '@mui/material';
import { DoorType } from 'graphql/generated/graphqlTypes';
import React from 'react';
import { getLockIcon } from 'utils/Lock/Lock';
import { DATAGRID_ROW_HEIGHT } from 'v2/constants';

interface Props {
  door: { name: string; type?: DoorType };
  height?: number;
}

const LockIconNameCell: React.FC<Props> = ({ door, height = DATAGRID_ROW_HEIGHT }) => (
  <Stack direction="row" alignItems="center" spacing={1} overflow="hidden" minWidth={0} height={height}>
    <Box width={24} height={24} display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
      {getLockIcon(door, { sx: (theme) => ({ color: theme.palette.text.secondary }) })}
    </Box>
    <Typography variant="caption" display="block" noWrap>
      {door.name}
    </Typography>
  </Stack>
);

export default LockIconNameCell;
